<template>
  <div class="video-container">
    <video v-if="!scannedCode" id="video-preview"></video>
  </div>
</template>

<script setup>
import { ref, defineEmits, onMounted, onBeforeUnmount } from "vue";
import { BrowserMultiFormatReader } from "@zxing/library";

const emit = defineEmits(['detect']);
const scannedCode = ref('');
let codeReader = null;

onMounted(() => {
  codeReader = new BrowserMultiFormatReader();

  codeReader.decodeFromVideoDevice(undefined, "video-preview", (result, err) => {
    if(result){
      scannedCode.value = result.text;
      codeReader.stopStreams();
      emit('detect', scannedCode.value);
    }
    if(err)
    console.log(err);
  });
});

onBeforeUnmount(() => {
  if(codeReader){
    codeReader.stopStreams();
  }
});
</script>

<style scoped>
.video-container {
  width: 80%; /* Ajustez la largeur selon vos besoins */
  height: 100px; /* Hauteur du conteneur pour montrer le centre de la vidéo */
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}

.video-container video {
  width: 100%; 
  position: absolute;
  top: 50%; 
  left: 0;
  transform: translateY(
    -50%
  );
}
</style>
